/**
 * @typedef {import("../../../../hooks/teacher/quest/useGetQuestByCategory").QuestType} QuestType
 */

/**
 * @param {{quest: QuestType}} props
 * @returns 
 */
const QuestCard = ({ quest }) => {
  return (
    <div className="quest-card-container">
      <div className="quest-card-image-container">
        <img src={quest.thumbnail_url} alt="Quest" className="quest-card-image" />
      </div>

      <div className="quest-card-text">
        <h2>Name : {quest.title}</h2>
        <p>Episodes : {quest.total_episodes}</p>
      </div>
    </div>
  );
};

export default QuestCard;
